import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {DeviceDetectorService} from "ngx-device-detector";

declare var jQuery;

// Relies on Window provider in app.module
const _window: Window = window;

@Injectable()
export class WebUtilService {

    constructor(@Inject(DOCUMENT) private document: any,
                private deviceService: DeviceDetectorService) {
    }

    getCurrentUrl(): string {
        return this.document.location.href;
    }

    scrollTop(): void {
        _window.scroll(0, 0);
    }

    openUrl(url: string, target: string): void {
        _window.open(url, target);
    }

    redirect(url: string): void {
        _window.location.href = url;
    }

    getOrigin(): string {
        return _window.location.origin;
    }

    getBaseHref() {
        return jQuery('base').attr('href');
    }

    getReferrer() {
        return this.document.referrer;
    }

    isIeOrEdge() {
        const browser = this.deviceService.getDeviceInfo().browser;
        return browser == 'ie' || browser == 'ms-edge';
    }
}
